export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/fd2bc97f-32aa-49ef-aa3e-bf94114d3937.jpg',
  product: 'https://cdn.magicpatterns.com/uploads/boTirLfvhzwF9iVwXxgCJr/Gemini_Generated_Image_bdo9yhbdo9yhbdo9.jpg',
  kitchen: 'https://cdn.magicpatterns.com/patterns/generated-images/8ba85376-f40a-4ab3-8398-add437b266ee.jpg',
  bathroom: 'https://cdn.magicpatterns.com/patterns/generated-images/6a4c429e-b8dc-4433-8468-a7bfa8aea112.jpg',
  livingroom: 'https://cdn.magicpatterns.com/patterns/generated-images/ab90b5db-ebc6-4f0e-8179-b3849745b2cb.jpg',
}
